import styles from './BgVideo.module.css';

import bgVideo from '../../assets/video/bgVideo.webm';
import bgPoster from '../../assets/images/bgPoster.webp';
import { useEffect, useRef } from 'react';

export const BgVideo = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.play();
      }
    }, 9560);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={styles.bgVideoWrapper}>
      <video
        ref={videoRef}
        playsInline
        muted="muted"
        loop
        poster={bgPoster}
        autoPlay={false}
      >
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
};
